import { render, staticRenderFns } from "./InactiveOutsourceHotPositions.vue?vue&type=template&id=46a51a44&scoped=true"
import script from "./InactiveOutsourceHotPositions.vue?vue&type=script&lang=js"
export * from "./InactiveOutsourceHotPositions.vue?vue&type=script&lang=js"
import style0 from "./InactiveOutsourceHotPositions.vue?vue&type=style&index=0&id=46a51a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a51a44",
  null
  
)

export default component.exports